const props = {
    index: {
        type: String,
        required: true
    },
    searchParameters: {
        required: false,
        type: Object,
        /**
         * Meilisearch search parameters.
         * @returns {import("@henrotaym/meilisearch-js/dist/filters/types/search").SearchParams}
         */
        default: () => ({})
    },
    value: { required: true },
    trackBy: { 
        required: false,
        type: Function,
        default: result => result.id
    },
    displayBy: { 
        required:false,
        type: Function,
        default: result => result.name
    }
}

const mixin = { props };

export { props as searchMixinProps };
export default mixin;